import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Divider, Grid, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import useHrIntegrations from "../../../../api/hooks/useHrIntegrations";
import GrayChip from "../../../../components/chips/GrayChip";
import CustomTooltipBorder from "../../../../components/CustomTooltipBorder";
import LabelComponentProp from "../../../../components/LabelComponentProp";

const UserAdminDetails = ({ user, handleHeSystemConnect }) => {
  const colors = useColors();
  const { isAnyHrIntegrated } = useHrIntegrations();

  const getNAChip = () => {
    return (
      <CustomTooltipBorder
        borderColor={colors.primary_main}
        title={
          isAnyHrIntegrated ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="caption">Data Unavailable</Typography>
              <Typography
                variant="caption"
                sx={{ color: colors.text_secondary }}
              >
                The HR system is connected, but it looks like the necessary data
                isn’t available yet. Please follow up with the relevant team to
                ensure the data is added.
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography variant="caption">Data Unavailable</Typography>
              <Typography
                variant="caption"
                sx={{ color: colors.text_secondary }}
              >
                connect your HR system to Breeze to view detailed info.
              </Typography>
              <Box
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                }}
                onClick={handleHeSystemConnect}
              >
                <Typography
                  variant="caption"
                  sx={{ color: colors.primary_main }}
                >
                  Go To Integration
                </Typography>
                <ArrowForwardIcon
                  sx={{ width: "12px", color: colors.primary_main }}
                />
              </Box>
            </Box>
          )
        }
      >
        <GrayChip text={"N/A"} />
      </CustomTooltipBorder>
    );
  };

  return (
    <Grid
      container
      gap={2}
      alignItems={"center"}
      rowGap={3}
      justifyContent={"space-evenly"}
    >
      <Grid item xs={3}>
        <LabelComponentProp label={"Title"}>
          {user.hr_info?.title ? user.hr_info?.title : getNAChip()}
        </LabelComponentProp>
      </Grid>
      <Divider orientation="vertical" flexItem />

      <Grid item xs={3}>
        <LabelComponentProp label={"Department"}>
          {user?.hr_info?.department ? user?.hr_info?.department : getNAChip()}
        </LabelComponentProp>
      </Grid>
      <Divider orientation="vertical" flexItem />

      <Grid item xs={3}>
        <LabelComponentProp label={"Site"}>
          {user.hr_info?.site ? user.hr_info?.site : getNAChip()}
        </LabelComponentProp>
      </Grid>
    </Grid>
  );
};

export default UserAdminDetails;
